// ------------------------------------------------------------------------------
// Icon System - Pure CSS Variables (No Hardcoded Colors)
// All colors now use CSS variables and dynamic conversion when needed
// ------------------------------------------------------------------------------

// Component exports
export { LogoSVG } from "./LogoSVG"
export { IconSVG } from "./IconSVG"
export {
  generateIconElements,
  generateSVGAttributes,
  generateSVGString,
  IconVariant,
} from "./iconUtils"
